export const datasetFilterValues = [
    {
        text: 'All',
        value: '0',
    },
    {
        text: 'Reviewed',
        value: '1',
    },
    {
        text: 'Unreviewed',
        value: '2',
    },
];
